import React, { useState, useEffect } from 'react'
import { Row, Col, Container, Dropdown, Nav, Tab, OverlayTrigger, Tooltip, Button, Modal } from 'react-bootstrap'
import Card from '../Card'
import CustomToggle from '../dropdowns'
import { Link, useNavigate, Route } from 'react-router-dom'
import { ToastProvider, useToasts } from 'react-toast-notifications';
import { apiHandler } from '../../api/apihandler';
import { CHALLENGE_PERTICIPANTS, COMMENT_LIST, COMMENT_POST, DELETE_COMMENT, FEEDS_LIST, FEED_DELETE, FEED_MEDIA_POST, FEED_POST, FOLLOWER_LIST, FOLLOWING_LIST, PROFILE_DETAILS } from "../../api/constants";
import Moment from 'moment';
import ReactFsLightbox from 'fslightbox-react';
import Swal from 'sweetalert2'
import EmojiPicker from 'emoji-picker-react';
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry';
import cross from '../../assets/images/icon/cross.png'
import video from '../../assets/images/small/video.png'
import SingleUserParticipate from './singleUserParticipate'


const ParticipateList = ({ postId, winnerParticipateId, setWinnerParticipateId }) => {
    const [show, setShow] = useState(false);
    const navigate = useNavigate();
    const { addToast } = useToasts();
    const [participantList, setParticipantList] = useState([]);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(1);
    const [loadingMore, setLoadingMore] = useState(false);

    useEffect(() => {
        getParticipantList(1)
    }, [])


    // limit:100 with no pagination silently hid every participant past the
    // first 100 on a popular challenge - page through with "Load more"
    // instead of fetching everything in one shot.
    async function getParticipantList(pageVal = 1) {
        setLoadingMore(true)
        try {
            const res = await apiHandler(CHALLENGE_PERTICIPANTS, "POST", {
                page: pageVal,
                limit: 100,
                post_id: postId
            })
            if (res.data?.response?.status === 200) {
                setMaxPage(res?.data?.data?.comments?.meta?.last_page || 1)
                setPage(pageVal)
                if (pageVal === 1) {
                    setParticipantList(res?.data?.data?.comments?.data || [])
                } else {
                    setParticipantList(prev => [...prev, ...(res?.data?.data?.comments?.data || [])])
                }
            } else {
                //navigate('/auth/sign-in')
                //addToast(res?.response?.data?.data?.message, { appearance: 'error' });
                //console.log("profileRes",res)
            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setLoadingMore(false)
        }
    }

    return (
        <>
            <div className="comment-area mt-3" style={{ marginTop: "10px" }}>
                <h5 style={{ marginTop: "5px", }}>List of Participants</h5>
                {
                    participantList?.map((elm, i) => (
                        <div>
                            <SingleUserParticipate postId={postId} commentElm={elm}
                                winnerParticipateId={winnerParticipateId}
                                setWinnerParticipateId={setWinnerParticipateId}
                                getParticipantList={getParticipantList} />
                            {/* {
                                elm?.replies?.map((innerElm, index) => (
                                    <div style={{marginLeft: "40px"}}>
                                        <SingleUserComment postId={postId} commentElm={innerElm} />
                                    </div>
                                ))
                            } */}
                        </div>
                    ))
                }
                {
                    page < maxPage ?
                        <div className="text-center mt-2">
                            <Button variant="primary" size="sm" disabled={loadingMore}
                                onClick={() => getParticipantList(page + 1)}>
                                {loadingMore ? 'Loading...' : 'Load more'}
                            </Button>
                        </div> : null
                }
            </div>
        </>
    )
}

export default ParticipateList
